// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryAd1-cls1_UkY","cls2":"PodcastLibraryAd1-cls2_Ysj PodcastLibraryAd1-cls1_UkY"};